import {
  srcSetWidths as defaultSrcSetWidths,
  generateSrcSet,
} from '@core/Components/HeycarImage/GenerateSrcSet';
import { clampSrcSetWidths } from '@umbraco/Utils/ClampSrcSetWidths';
import { getAbsoluteMediaUrl } from '@umbraco/Utils/GetAbsoluteMediaUrl';
import { umbracoImageLoader } from '@umbraco/Utils/UmbracoImageLoader';

import styles from './MediaImage.module.css';

type MediaImageProps = {
  image: { url: string; name: string; width: number };
  alt: string;
  sizes?: string;
  objectFit?: 'contain' | 'cover';
  className?: string;
  loading?: 'lazy' | 'eager';
  priority?: boolean;
  srcSetWidths?: number[];
};

export const MediaImage = ({
  image,
  alt,
  sizes,
  objectFit,
  className,
  loading,
  priority,
  srcSetWidths,
}: MediaImageProps) => {
  const absoluteUrl = getAbsoluteMediaUrl(image.url);
  const widths = clampSrcSetWidths(srcSetWidths ?? defaultSrcSetWidths, image.width);

  return (
    <img
      src={absoluteUrl}
      srcSet={absoluteUrl ? generateSrcSet(absoluteUrl, umbracoImageLoader, widths) : undefined}
      alt={alt}
      sizes={sizes}
      className={`${styles.image} ${className ?? ''}`.trim()}
      style={objectFit ? { objectFit } : undefined}
      loading={priority ? 'eager' : (loading ?? 'lazy')}
      fetchPriority={priority ? 'high' : undefined}
    />
  );
};
